<script setup lang="ts">
import { isExpand } from "@/views/Home/useData/useHomePage";
import { computed } from "vue";

const toolTips = computed(() => {
  return isExpand.value ? "收起侧边栏" : "打开侧边栏";
});
</script>

<template>
  <div class="header">
    <div class="expand-bar" v-if="isExpand">
      <div class="tag"></div>
      <div class="center-title">AI对话</div>
      <el-tooltip
        class="box-item"
        effect="dark"
        :content="toolTips"
        placement="right"
      >
        <div class="border-btn">
          <img
            src="../../../assets/open.png"
            height="18"
            width="18"
            @click="isExpand = !isExpand"
          />
        </div>
      </el-tooltip>
    </div>
    <div class="title" v-if="false">deep R1满血版</div>
    <div class="compact-mode" v-if="!isExpand" @click="isExpand = !isExpand">
      <img src="@/assets/logo.png" class="logo" alt="" />
      <el-tooltip
        class="box-item"
        effect="dark"
        :content="toolTips"
        placement="right"
      >
        <div class="border-btn">
          <img src="../../../assets/open.png" height="18" width="18" />
        </div>
      </el-tooltip>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.header {
  padding: 25px 15px;
  padding-bottom: 0px;
  width: 100%;
  //height: 42px;
  gap: 4px;
  display: flex;
  flex-direction: column;

  .expand-bar {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;

    .tag {
      //background-color: #4d6bfe;
      font-size: 14px;
      padding: 4px 10px;
      color: #fff;
      font-weight: 500;
      border-top-left-radius: 14px; /* 左上角圆角 */
      border-bottom-right-radius: 14px; /* 右下角圆角 */
    }

    .center-title {
      font-size: 15px;
      font-weight: bold;
    }

    .expand-btn {
      size: 28px;
      cursor: pointer;
      border-radius: 4px;
      &:hover {
        background-color: #4d6bfe55;
      }
    }
  }

  .title {
    font-size: 26px;
    font-weight: bold;
  }

  .logo {
    width: 32px;
    height: 32px;
  }

  .compact-mode {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    //gap: 30px;
    cursor: pointer;
  }
}
</style>
